import * as React from "react";
import Box from "@mui/material/Box";

export default function Playground() {
  return <Box sx={{ flexGrow: 1 }}>For testing purposes only</Box>;
}
